import axios from "axios";
import Router from "router/index";
import { ToastObject } from "vue-toasted";
import { showToast } from "utils/Toast";

// const token = document.head.querySelector('meta[name="csrf-token"]');

// if (token) {
//     axios.defaults.headers.common['X-CSRF-TOKEN'] = token.getAttribute('content');
// } else {
//     console.error('CSRF token not found');
// }

axios.interceptors.response.use(
  (r) => r,
  (error) => {
    // The tenant got suspended while the app was open: reload on the
    // suspended page, which fetches the renewal contact.
    if (error?.response?.status === 423) {
      if (window.location.pathname !== "/accesso-sospeso") {
        window.location.assign("/accesso-sospeso");
      }
      return Promise.reject(error);
    }
    if (error?.response?.status === 422 || error?.response?.status === 404) {
      return Promise.reject(error);
    }

    const message =
      (error.response?.data &&
        ((error.response.data.errors && error.response.data.errors.message) ||
          error.response.data.message)) ||
      error.message;
    // Through the helper: the message comes from the server and is shown
    // as plain text.
    showToast(message, {
      position: "bottom-right",
      type: "error",
      duration: 5000,
      action: {
        text: "Chiudi",
        onClick(e: MouseEvent, toastObject: ToastObject) {
          toastObject.goAway(0);
        },
      },
    });
    if (error?.response?.status === 401) {
      if (Router.currentRoute.name !== "login") {
        Router.push("/login");
      }
    }
    return Promise.reject(error);
  }
);
